import { connect } from 'react-redux';

import { getApplicationById, resetMeta, resetPage } from '../../actions/ApplicationPage/BookingApplication';

import ApplicationDetailPage from './ApplicationDetailPage';

const mapsStateToProps = state => ({
	pageProps: state.applicationDetailPage.applicationBasicPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getApplicationById(id) {
		dispatch(getApplicationById(id));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(ApplicationDetailPage);
